<template>
    <div style="padding: 100px 8%;">
        <div class="col-12">
            <h4>編輯保障設定</h4>
            <form class="form panel panel-form bg-white">
                <div class="row">
                    <div class="col-4">
                        <label class="d-inline-block" for="">
                            API Type/Report Type：
                            <span class="text-secondary">{{ formData.report }}</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="reportName">保障設定名稱：</label>
                        <input class="form-control form-control-inline w-50" id="reportName" type="text" maxlength="20" v-model="formData.report_name"/>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="">
                            更新日期：
                            <span class="text-secondary">{{ currentDate }}</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="">
                            資料階層數：
                            <span class="text-secondary">{{ formData.shell_level }} (不含中項保障群組層)</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="">
                            金額總計顯示於：
                            <span v-if="formData.sum_position === '0'" class="text-secondary">中項保障</span>
                            <span v-if="formData.sum_position === '1'" class="text-secondary">最後一層(不含中項)</span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="d-inline-block" for="memo">備註：</label>
                        <input class="form-control form-control-inline w-75" id="memo" type="text" maxlength="20" v-model="formData.memo"/>
                    </div>
                </div>
                <hr class="hr-dashed mg-b-40"> <!--分隔線-->
                <div v-if="isLoading">
                    <Message
                        class="mt-5 mb-4 d-flex justify-content-center"
                        loading
                        message="資料讀取中，請稍候..."
                    />
                </div>
                <div v-else-if="isError" class="container mt-3">
                    <Message
                        class="mt-5 mb-4 d-flex justify-content-center"
                        message="資料載入失敗，請洽相關人員"
                    />
                </div>
                <div v-else class="row">
                    <!-- 左方編輯區 -->
                    <div class="col-4 mb-3">
                        <!-- 一般保障 -->
                        <report-setting-form
                            :isOther="false"
                            :shellLevel="formData.shell_level"
                            :sumPosition="formData.sum_position"
                            :settings="settings"
                            @showMidCoverageInfo="showMidCoverageInfo"
                            @showSpecialConditionInfo="showSpecialConditionInfo"
                            @create="addPreviousAction('create', false)"
                        ></report-setting-form>
                        <!-- 其他保障 -->
                        <template v-if="showOther">
                            <hr>
                            <label for="sumPosition">是否需要其他保障：</label>
                            <div class="radio radio-inline ml-1">
                                <input type="radio" id="otherCoverageY" v-model="hasOther" value="Y" :disabled="isOtherCoverageDisabled">
                                <label for="otherCoverageY">是</label>
                            </div>
                            <div class="radio radio-inline">
                                <input type="radio" id="otherCoverageN" v-model="hasOther" value="N" :disabled="isOtherCoverageDisabled">
                                <label for="otherCoverageN">否</label>
                            </div>
                            <report-setting-form
                                v-if="hasOther === 'Y' && !isOtherCoverageDisabled"
                                :data="otherSettings"
                                :isOther="true"
                                :shellLevel="formData.shell_level"
                                :sumPosition="formData.sum_position"
                                :settings="settings"
                                @create="createOtherCoverage"
                            ></report-setting-form>
                        </template>
                    </div>
                    <!-- 右方預覽區 -->
                    <div class="col-8 mb-3">
                        <report-setting-tree
                            :data="settings"
                            :previousActions="previousActions"
                            @delete="onDeleteNode"
                            @editCoverage="onEditCoverage"
                            @undoEdit="onUndoEdit"
                            @recoverAll="onRecoverAll"
                            @beforeModifyNode="onBeforeModifyNode"
                        ></report-setting-tree>
                    </div>
                    <!-- 異動原因 -->
                    <div class="col-12 d-flex text-right mb-3">
                        <label class="flex-shrink-0 mr-2" for="reason">異動原因：</label>
                        <textarea
                            id="reason"
                            v-model="formData.modification_reason"
                            class="form-control"
                            rows="4"
                            maxlength="400"
                        ></textarea>
                    </div>
                    <!-- 按鈕區 -->
                    <div class="col-12 text-right mb-3">
                        <button class="btn btn-default" @click.stop.prevent="$router.go(-1)">取消</button>
                        <button class="btn btn-primary" @click.stop.prevent="onUpdateValidate()">存檔</button>
                        <button class="btn btn-primary" @click.stop.prevent="onCheck()" :disabled="!canCheck">覆核生效</button>
                    </div>
                    <!-- 異動列表 -->
                    <div class="col">
                        <record-data-table :data="records"></record-data-table>
                    </div>
                </div>
            </form>
        </div>
        <SmallCategoryShowModal          
            :open="smallCategoryShowModalOpen"
            :data="midCoverageData"
            @confirm="panelClose('smallCategoryShowModalOpen')">
        </SmallCategoryShowModal>
        <SpecialConditionDetailModal
          :open="specialConditionDetailModalOpen"
          :code="detailData.code"
          :codename="detailData.codename"
          @confirm="panelClose('specialConditionDetailModalOpen')"
        ></SpecialConditionDetailModal>
        <ReportSettingCoverageEditModal
            :open="reportSettingCoverageEditModalOpen"
            :data="coverageData"
            @confirm="onConfirmEditCoverage"
            @close="panelClose('reportSettingCoverageEditModalOpen')">
        </ReportSettingCoverageEditModal>
        <ConfirmModal
            :open="confirmModalOpen"
            @confirm="onConfirm"
            @close="panelClose('confirmModalOpen')">
            <template slot="title">
                <template v-if="confirmType === 'delete'">確認是否刪除？</template>
                <template v-else-if="confirmType === 'recover'">確認是否全部復原？</template>
                <template v-else-if="confirmType === 'update'">是否確認要儲存？</template>
                <template v-else-if="confirmType === 'check'">是否確認要覆核生效？</template>
            </template>
            <template slot="content">
                <template v-if="confirmType === 'update'">確認存檔後將一併刪除無存在中項保障群組之空白階層，請留意！</template>
            </template>
        </ConfirmModal>
        <report-setting-footer :data="formData" :canCopy="canCopy"></report-setting-footer>
    </div>
</template>
  
<script>
import Message from "@/desktop/components/Message.vue";
import { commonMixin } from "@/mixins/common";
import ReportSettingForm from './components/ReportSettingForm.vue';
import ReportSettingTree from './components/ReportSettingTree.vue';
import ReportSettingFooter from './components/ReportSettingFooter.vue';
import SmallCategoryShowModal from "./components/SmallCategoryShowModal.vue";
import SpecialConditionDetailModal from "./components/SpecialConditionDetailModal.vue";
import ReportSettingCoverageEditModal from "./components/ReportSettingCoverageEditModal.vue";
import ConfirmModal from "./components/ConfirmModal.vue";
import RecordDataTable from "./components/RecordDataTable.vue";
import { getReportSettings, getReportChangeRecords, updateReport, saveReport } from "@/service";

export default {
    name: "ReportSetting",
    mixins: [commonMixin],
    components: { 
        Message,
        ReportSettingForm,
        ReportSettingTree,
        ReportSettingFooter,
        SmallCategoryShowModal,
        SpecialConditionDetailModal,
        ReportSettingCoverageEditModal,
        ConfirmModal,
        RecordDataTable,
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            currentDate: "",
            records: [],
            settings: [],
            otherSettings: [],
            hasOther: "N",
            isOtherCoverageDisabled: false,
            originalData: { // 全部復原按鈕使用
                settings: "",
                otherSettings: "",
                hasOther: "N",
                isOtherCoverageDisabled: false,
            },
            formData: {
                report: "",
                report_name: "",
                settings: "",
                othersettings: "",
                responsecategory: [],
                shell_level: null,
                sum_position: "",
                modification_reason: "",
                memo: "",
                status: "0",
                creator: "",
                creatorname: "",
            },
            // 中項保障彈窗開關
            smallCategoryShowModalOpen: false, 
            // 中項保障彈窗資料
            midCoverageData: { 
                midCode: "",
                midName: "",
            },
            // 特殊條件彈窗開關
            specialConditionDetailModalOpen: false, 
            // 特殊條件彈窗資料
            detailData: { 
                code: "",
                codename: "",
            },
            // 編輯保障彈窗開關
            reportSettingCoverageEditModalOpen: false, 
            // 編輯保障彈窗資料
            coverageData: [], 
            // 確認彈窗開關
            confirmModalOpen: false, 
            // 確認彈窗類型 (delete:刪除節點, update:存檔, check:覆核生效, recover:全部復原)
            confirmType: "", 
            // 確認刪除後要刪除的資料
            deleteData: [], 
            previousActions: [],
            canCheck: false,
            canCopy: false,
        };
    },
    computed: {
        showOther() {
            return !(this.formData.shell_level == 0
                    || (this.formData.shell_level == 1 && this.formData.sum_position === "1"));
        }
    },
    methods: {
        init() {
            this.currentDate = this.getCurrentDate();
            this.userID = this.$store.state.userInfo.id;
            this.formData.creator = this.$store.state.userInfo.id;
            this.formData.creatorname = this.$store.state.userInfo.name;
            this.formData.report = this.$route.params.report;
            this.formData.modification_reason = "";
            this.previousActions = [];
        },
        /** 按下存檔按鈕的事件與檢核 */
        onUpdateValidate() {
            if (!this.formData.modification_reason) {
                this.$toast.info({ title: "請輸入異動原因" });
                return;
            }
            // 確認存檔彈窗
            this.confirmType = "update";
            this.panelOpen('confirmModalOpen');
        },
        /** 按下覆核生效按鈕的事件 */
        onCheck() {
            // 確認覆核生效彈窗
            this.confirmType = "check";
            this.panelOpen('confirmModalOpen');
        },
        /** 增加回上一步的步驟 */
        addPreviousAction(type, isother) {
            let action = {
                settings: JSON.stringify(this.settings)
            };
            if (type === 'create' && isother) {
                action.hasOther = "N";
                action.isOtherCoverageDisabled = false;
            }
            if (type === 'delete' && isother) {
                action.hasOther = "Y";
                action.isOtherCoverageDisabled = true;
            }
            this.previousActions.length == 10 && this.previousActions.shift();
            this.previousActions.push(action);
        },
        createOtherCoverage(data) {
            this.isOtherCoverageDisabled = true;
            if (this.otherSettings.length > 0) this.otherSettings.pop()
            data.forEach(element => {
                this.otherSettings.push({
                    code: element.code,
                    category: element.category,
                })
            });
            this.addPreviousAction('create', true);
        },
        showMidCoverageInfo(data) {
            this.midCoverageData.midCode = data.code;
            this.midCoverageData.midName = data.codename;
            this.panelOpen('smallCategoryShowModalOpen');
        },
        showSpecialConditionInfo(data) {
            this.detailData.code = data.code;
            this.detailData.codename = data.codename;
            this.panelOpen('specialConditionDetailModalOpen');
        },
        onEditCoverage(data) {
            this.coverageData = data;
            this.panelOpen('reportSettingCoverageEditModalOpen');
        },
        onConfirmEditCoverage(oldCoverageDataList, newCoverage, newDetail) {
            let nodelist = this.settings;
            let node;
            for (let i = 0; i < oldCoverageDataList.length; i++) {
                node = nodelist.find(x => x.code+x.category == oldCoverageDataList[i].code+oldCoverageDataList[i].category)
                if (i == oldCoverageDataList.length - 1) {
                    node.code = newDetail.code ? newCoverage.code+"_"+newDetail.code : newCoverage.code;
                    node.category = newDetail.codename ? newCoverage.codename+"_"+newDetail.codename : newCoverage.codename;
                    node.coverage = newCoverage.code;
                    node.coveragename = newCoverage.codename;
                    node.detail = newDetail.code;
                    node.detailname = newDetail.codename;
                } else {
                    nodelist = node.children;
                }
            }
            this.panelClose('reportSettingCoverageEditModalOpen');
        },
        onUndoEdit() {
            // 回上一步
            let prevAction = this.previousActions.pop()
            this.settings = JSON.parse(prevAction.settings);
        },
        onRecoverAll() {
            // 確認全部復原彈窗
            this.confirmType = "recover";
            this.panelOpen("confirmModalOpen");
        },
        onBeforeModifyNode(type) {
            this.addPreviousAction(type)
        },
        onDeleteNode(data) {
            // 確認刪除彈窗
            this.confirmType = "delete";
            this.deleteData = data;
            this.panelOpen("confirmModalOpen");
        },
        onConfirm() {
            switch (this.confirmType) {
                case "delete": this.doDeleteNode(); break;
                case "update": this.doUpdateReport(); break;
                case "check": this.doSaveReport(); break;
                case "recover": this.doRecoverAll(); break;
                default: break;
            }
            this.panelClose("confirmModalOpen")
        },
        doDeleteNode() {
            let nodelist = this.settings;
            let node;
            let isother = false;
            for (let i = 0; i < this.deleteData.length; i++) {
                node = nodelist.find(x => x.code+x.category == this.deleteData[i].code+this.deleteData[i].category)
                if (i == this.deleteData.length - 1) {
                    isother = node.isother
                } else {
                    nodelist = node.children;
                }
            }
            this.addPreviousAction('delete', isother)
            const index = nodelist.indexOf(node);
            if (index !== -1) {
                nodelist.splice(index, 1);
            }
            if (isother) {
                this.hasOther = "N";
                this.isOtherCoverageDisabled = false;
            }
        },
        doRecoverAll() {
            // 全部復原
            this.settings = JSON.parse(this.formData.settings);
            this.otherSettings = JSON.parse(this.formData.othersettings);
            this.hasOther = this.originalData.hasOther;
            this.isOtherCoverageDisabled = this.originalData.isOtherCoverageDisabled;
            this.previousActions = [];
        },
        /** 存檔保障內容設定 */
        async doUpdateReport() {
            let reqData = JSON.parse(JSON.stringify(this.formData));
            reqData.settings = JSON.stringify(this.settings);
            if (this.hasOther == "Y") {
                reqData.othersettings = JSON.stringify(this.otherSettings);
            } else {
                delete reqData.othersettings;
            }
            await updateReport(this.userID, reqData).then((result) => {
                if (result.header && result.header.status == "200") {
                    this.$toast.info({ title: "更新保障設定成功" });
                    this.getReportRecords();
                    this.canCheck = false; // 存檔後此人員就不能覆核生效
                } else {
                    this.$toast.info({ title: result.header.message });
                }
            });
        },
        /** 覆核生效保障內容設定 */
        async doSaveReport() {
            await saveReport(this.userID, this.formData.report).then((result) => {
                if (result.header && result.header.status == "200") {
                    this.$toast.info({ title: "保障設定覆核生效成功" });
                    this.canCheck = false;
                } else {
                    this.$toast.info({ title: result.header.message });
                }
            });
        },
        /** 查詢保障內容設定 */
        async getReportData() {
            this.init();
            this.isLoading = true; 
            getReportSettings(
                this.$store.state.userInfo.id, 
                this.formData.report
            ).then(result => {
                if (result.header.status == "200" && result.body) {
                    localStorage.coverageOptionList = JSON.stringify(result.body.coveragecodelist);
                    localStorage.specialConditionList = JSON.stringify(result.body.specialconditionlist);
                    this.settings = result.body.settings;
                    this.otherSettings = result.body.othersettings;
                    this.hasOther = result.body.othersettings && result.body.othersettings.length > 0 ? "Y" : "N";
                    this.isOtherCoverageDisabled = !!this.otherSettings && this.otherSettings.length > 0;
                    this.records = result.body.records;
                    this.canCheck = result.body.cancheck;
                    this.canCopy = result.body.cancopy;

                    this.originalData.hasOther = this.hasOther;
                    this.originalData.isOtherCoverageDisabled = this.isOtherCoverageDisabled;
                    
                    this.formData.settings = JSON.stringify(result.body.settings);
                    this.formData.othersettings = JSON.stringify(result.body.othersettings);
                    this.formData.responsecategory = result.body.responsecategory;
                    this.formData.sum_position = result.body.sum_position;
                    this.formData.shell_level = result.body.shell_level;
                    this.formData.report_name = result.body.report_name;
                    this.formData.memo = result.body.memo;
                } else {
                    this.isError = true;
                }
                this.isLoading = false;
            });
        },
        /** 查詢異動紀錄 */
        async getReportRecords() {
            getReportChangeRecords(
                this.$store.state.userInfo.id, 
                this.formData.report
            ).then(result => {
                if (result.header.status == "200" && result.body) {
                    this.records = result.body;
                    this.formData.modification_reason = "";
                }
            });
        },
    },
    mounted() {
        this.getReportData();
    },
};
</script>

<style lang="scss" scoped>
.hr-dashed {
  border: 0;
  border-top: 2px dashed #a2a9b6;
}
</style>
